module.exports = __webpack_public_path__ + "img/img3.45dc2feb.jpg";